import React from 'react';
import PropTypes from 'prop-types';
import ImageLoader from './ImageLoader';
import ImageLazyLoader from './ImageLazyLoader';

const Image = React.memo(({ src, srcSet, onLoad, width, height, lazy, cover, ...rest }) => {
  if (lazy) return <ImageLazyLoader src={src} srcSet={srcSet} onLoad={onLoad} cover={cover} width={width} height={height} {...rest} />;
  return <ImageLoader src={src} srcSet={srcSet} onLoad={onLoad} cover={cover} width={width} height={height} {...rest} />;
});

Image.displayName = 'Image';

Image.propTypes = {
  src: PropTypes.string,
  srcSet: PropTypes.string,
  onLoad: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  lazy: PropTypes.bool,
  cover: PropTypes.bool,
};

Image.defaultProps = {
  src: null,
  srcSet: null,
  onLoad: null,
  width: null,
  height: null,
  lazy: false,
  cover: true,
};

export default Image;
